
import { Component, Mixins } from "vue-property-decorator";
import { IFocusBehavior } from "../../../../../../documaker/domain/format/objects";
import { IFocusBehaviorPropertyEditable, instanceOfIFocusBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class FocusBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IFocusBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IFocusBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isFocusBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIFocusBehaviorPropertyEditable(s) && s.focusBehavior().isEditable(), false);
  }

  get focusBehavior(): IFocusBehavior {
    return this.readPropertyOrDefault(s => s.focusBehavior().getValue(), { isEnable: false });
  }

  set focusBehavior(value: IFocusBehavior) {
    this.writePropertyWhenValid(s => s.focusBehavior().setValue(value));
  }
}
